import { render, staticRenderFns } from "./AuthLogon.vue?vue&type=template&id=33f23b34&"
import script from "./AuthLogon.vue?vue&type=script&lang=js&"
export * from "./AuthLogon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports